export const formularioSlice = (set,get) => ({
    estatus: [{value:1,label:"Activo"},{value:2,label:"Oculto"}],
    handleChange: (e) => {
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
        const extra = e.target.name === 'tipo' ? { tipoId: "" } : {};
        set({ datos:{ ...get().datos, [e.target.name]: value, ...extra } });
    },
})
